export enum InvoiceStatus {
  SENT = "Sent",
  REVIEWED = "Reviewed",
  NOT_REVIEWED = "Not reviewed",
}

export enum QuickbookStatus {
  SYNCED = "Synced",
  NOT_SYNCED = "Not synced",
}

export enum InvoiceRecordStatus {
  ERROR = "error",
  WARN = "warn",
}

export enum GenerationStatus {
  IDLE = "IDLE",
  IN_PROGRESS = "IN_PROGRESS",
};

export enum InvoiceFilterIds {
  CUSTOMERS = "customers",
  JOBS = "jobs",
  ORDERS = "orders",
  INVOICES = "invoices",
  SYNC_STATUS = "syncStatus",
  INVOICE_STATUS = "invoiceStatus",
}

export enum UpdateInvoiceStatusKey {
  INVOICE_STATUS = "invoiceStatus",
  SYNC_STATUS = "syncStatus",
}
